import React from "react";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";

const Footer = (): React.ReactElement => {
  const theme = useTheme();
  const location = useLocation();
  const isNotHome =
    location.pathname.includes("privacy-policy") ||
    location.pathname.includes("terms-of-use");

  return (
    <Box
      component="footer"
      sx={{ bgcolor: "background.paper"}}
    >
      {!isNotHome && (
        <Grid container alignItems="center" justifyContent="center">
        <a
          target="_blank"
          rel="noreferrer"
          href="https://icons8.com/icon/rZwnRdJyYqRi/google-play"
        >
          Google Play{" "}
        </a>{" "}
        icon by{" "}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://icons8.com"
          style={{ marginRight: theme.spacing(2) }}
        >
          Icons8
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://icons8.com/icon/4PbFeZOKAc61/app-store"
        >
          App Store
        </a>{" "}
        icon by{" "}
        <a target="_blank" rel="noreferrer" href="https://icons8.com">
          Icons8
        </a>
      </Grid>
      )}

      <Box mt={2}>
        <Typography variant="body2" color="textSecondary" align="center">
          © {new Date().getFullYear()} My Company Name. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
